<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <BoardForm @submit-requested="submitRequested"></BoardForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import BoardForm from './BoardForm.vue'

  export default {
  components: { BoardForm },
  methods: {
    ...mapActions('boards', ['postBoard']),
    submitRequested (input) {
      this.postBoard(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 